import dynamic from 'next/dynamic';
import { useWindowSize } from '@hooks/useWindowSize';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAuth } from '@hooks/useAuth';

const HomeLoggedInIndex = dynamic(() => {
  const promise = import('@screens/home/homeLoggedIn').then(
    (mod) => mod.HomeLoggedIn,
  );
  return promise;
});

const HomeLoggedOutIndex = dynamic(() => {
  const promise = import('@screens/home/homeLoggedOut').then(
    (mod) => mod.HomeLoggedOut,
  );
  return promise;
});

export function BasePage() {
  const { width } = useWindowSize();
  const router = useRouter();
  const { appUser: user } = useAuth();

  useEffect(
    function handleNoModalAndHome() {
      if (router.query.pathname === '/' && width <= 900) {
        const query = Object.fromEntries(
          Object.entries(router.query).filter(([key]) => key !== 'pathname'),
        );
        const url = {
          pathname: '/',
          query,
        };
        void router.replace(url, url);
      }
    },
    [router, width],
  );
  if (width > 900 && user) return <HomeLoggedInIndex />;
  return <HomeLoggedOutIndex />;
}
